import { useInfiniteQuery, useQuery } from '@tanstack/react-query'
import { useToast } from '../../view/components/ui/use-toast'
import { useEffect, useState } from 'react'
import { configService } from '../services/configService'
import { tableService } from '../services/tableService'
import { TableParams } from '../services/tableService/table'
import { useAuth } from './useAuth'

export const useDefaultGoals = () => {
  const [params, setParams] = useState<TableParams>()
  const { isAdmin, isSuperAdmin } = useAuth()

  const {
    isError,
    isFetching,
    data: config,
    isLoading,
  } = useQuery({
    queryKey: ['defaultGoals'],
    queryFn: () => configService.getDefaultTeam(),
    enabled: isAdmin || isSuperAdmin,
  })
  const configTable = config?.commissionV2 || []

  const handleTableData = async ({ pageParam = 0 }) => {
    const response = await tableService.table({
      ...params,
      skip: pageParam,
      limit: 99,
    })

    return response
  }

  const {
    data: tables,
    fetchNextPage,
    hasNextPage,
    isLoading: loadingTables,
    isFetching: isFetchingTables,
    isError: isErrorTables,
  } = useInfiniteQuery({
    queryKey: ['allTables', params],
    queryFn: handleTableData,
    getNextPageParam: (lastPage) => {
      if (
        lastPage.pagination.skip + lastPage.pagination.limit ===
        lastPage.pagination.total / lastPage.pagination.limit
      ) {
        return null
      }
      return lastPage.pagination.skip + lastPage.pagination.limit
    },
    initialPageParam: undefined,
  })

  const commissionItems = Array.isArray(tables?.pages?.[0]?.tables)
    ? tables.pages[0].tables
        .filter((table) => table.isActive !== false)
        .map((table) => {
          const match = configTable.find((c) => c.name === table.name)
          return {
            label: table.name,
            value: String(table.maxPercents),
            leader: match?.leader,
            seller: match?.seller,
            max: table?.maxPercents,
          }
        })
    : []

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregador os dados, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    tables,
    fetchNextPage,
    hasNextPage,
    loadingTables,
    isFetchingTables,
    isErrorTables,
    commissionItems,
    isFetching,
    setParams,
    isLoading,
    config,
  }
}
